import { getActiveWorkspaceSlug } from "./workspaceStorage";

/** Slug do tenant ativo para chaves de cache (react-query). */
export function getWorkspaceQueryScope() {
  return getActiveWorkspaceSlug() || "__none__";
}

/** Prefixa a chave do react-query com o workspace ativo. */
export function workspaceScopedQueryKey(base, ...parts) {
  return [
    base,
    getWorkspaceQueryScope(),
    ...parts.filter((part) => part !== undefined && part !== null),
  ];
}
